import { useQuery } from 'react-query';

import { Article } from '@interfaces/homepage';
import { getRecommendedArticles } from '@utils/backend-api/articles';

const ARTICLE_RECOMMENDATION_LIST = 'ARTICLE_RECOMMENDATION_LIST';

export default function useArticlesBySlug({ articleSlugs }: { articleSlugs: string[] }) {
  const { data, isLoading } = useQuery<Article[]>([ARTICLE_RECOMMENDATION_LIST, articleSlugs], () =>
    getRecommendedArticles({ articleSlugs })
  );

  return { data, isLoading };
}
